import React, { useEffect, useRef, useState } from "react";
import BestOffer from "./BestOffer";
import { NavLink } from "react-router-dom";
import Logo from "./../../assets/images/logo.svg";
import Down from "./../../assets/images/down.svg";

export default function Navigation(props) {
  const { offer, myname } = props;
  const [toggle, setToggle] = useState(false);
  const [show, setShow] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isAboutOpen, setIsAboutOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
  const [isSolutionsOpen, setIsSolutionsOpen] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", controlNavbar);

      // cleanup function
      return () => {
        window.removeEventListener("scroll", controlNavbar);
      };
    }
  }, [lastScrollY]);

  const handleToggle = () => {
    setToggle(!toggle);
  };

  const controlNavbar = () => {
    if (typeof window !== "undefined") {
      if (window.scrollY > lastScrollY) {
        // if scroll down hide the navbar
        setShow(false);
      } else {
        // if scroll up show the navbar
        setShow(true);
      }

      // remember current page location to use in the next move
      setLastScrollY(window.scrollY);
    }
  };

  const aboutDropdownRef = useRef(null);
  const servicesDropdownRef = useRef(null);
  const industriesDropdownRef = useRef(null);
  const solutionsDropdownRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (aboutDropdownRef.current && !aboutDropdownRef.current.contains(event.target)) {
        setIsAboutOpen(false);
      }
      if (servicesDropdownRef.current && !servicesDropdownRef.current.contains(event.target)) {
        setIsServicesOpen(false);
      }
      if (industriesDropdownRef.current && !industriesDropdownRef.current.contains(event.target)) {
        setIsIndustriesOpen(false);
      }
      if (solutionsDropdownRef.current && !solutionsDropdownRef.current.contains(event.target)) {
        setIsSolutionsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);

  const toggleAboutDropdown = () => {
    setIsAboutOpen(!isAboutOpen);
  };

  const toggleServicesDropdown = () => {
    setIsServicesOpen(!isServicesOpen);
  };

  const toggleIndustriesDropdown = () => {
    setIsIndustriesOpen(!isIndustriesOpen);
  };

  const toggleSolutionsDropdown = () => {
    setIsSolutionsOpen(!isSolutionsOpen);
  };

  return (
    <div className={`nav_container ${show ? '' : 'hidden'} ${toggle ? "toggled" : ""}`}>
      {offer && <BestOffer />}
      <section className={`navigation`}>
        <div className="container">
          <div className="nav_wrapper">
            <div className="logo">
              <NavLink to="/">
                <img src={Logo} alt="" />
              </NavLink>
            </div>
            <div className="links">
              <NavLink to="/">Home</NavLink>
              {/* Desktop Solutions dropdown (opens on hover via CSS like other menus) */}
              {/* <NavLink to="/solutions" className="dropped">
                Solutions <img src={Down} alt="" />
                <div className="dropdown_content">
                  <NavLink to="/solutions/ai-powered-solutions" className="content_row">
                    Healthcare Solutions
                  </NavLink>
                  <NavLink to="/solutions/cloud-solutions" className="content_row">
                    E-commerce Solutions
                  </NavLink>
                  <NavLink to="/solutions/data-analytics" className="content_row">
                    Communication Solutions
                  </NavLink>
                </div>
              </NavLink> */}
              <NavLink to='/services' className="dropped"> Services <img src={Down} alt="" />
                <div className='dropdown_content' style={{ minWidth: "227px" }}>
                  <NavLink onClick={toggleServicesDropdown} to='/services/mcp-development' className="content_row">MCP Development</NavLink>
                  <NavLink onClick={toggleServicesDropdown} to='/services/mobile-app-development' className="content_row">Mobile App Development</NavLink>
                  <NavLink onClick={toggleServicesDropdown} to='/services/web-app-development' className="content_row">Web App Development</NavLink>
                  <NavLink onClick={toggleServicesDropdown} to='/services/ui-ux-designing' className="content_row">UI/UX Designing</NavLink>
                  <NavLink onClick={toggleServicesDropdown} to='/services/ai-machine-learning-development' className="content_row">AI/Machine Learning Development</NavLink>

                </div>
              </NavLink>
            
              <NavLink to='/industries' className="dropped"> Industries <img src={Down} alt="" />
                <div className='dropdown_content'>
                  <NavLink onClick={toggleIndustriesDropdown} to="/industries/education" className="content_row">Education</NavLink>
                  <NavLink onClick={toggleIndustriesDropdown} to="/industries/healthcare" className="content_row">Healthcare Industry</NavLink>
                  <NavLink onClick={toggleIndustriesDropdown} to="/industries/petcare" className="content_row">PetCare Industry</NavLink>
                  <NavLink onClick={toggleIndustriesDropdown} to="/industries/homecare" className="content_row">Homecare</NavLink>
                  <NavLink onClick={toggleIndustriesDropdown} to="/industries/social-media" className="content_row">Social Media App</NavLink>
                  <NavLink onClick={toggleIndustriesDropdown} to="/industries/dating" className="content_row">Dating app</NavLink>
                  <NavLink onClick={toggleIndustriesDropdown} to="/industries/fitness" className="content_row">Fitness</NavLink>
                  <NavLink onClick={toggleIndustriesDropdown} to="/industries/textile-garments" className="content_row">Textile Garments</NavLink>
                </div>
              </NavLink>

              <NavLink to='/about' className="dropped"> About Us <img src={Down} alt="" />
                <div className='dropdown_content'>
                  <NavLink onClick={toggleAboutDropdown} to='/about' className="content_row">About Us</NavLink>
                  <NavLink onClick={toggleAboutDropdown} to='/our-story' className="content_row">Our Story</NavLink>
                  <NavLink onClick={toggleAboutDropdown} to='/our-journey' className="content_row">Our Journey</NavLink>
                  <NavLink onClick={toggleAboutDropdown} to='/life-at-koolmind' className="content_row">Life at KoolMind</NavLink>
                  <NavLink onClick={toggleAboutDropdown} to="/career" className="content_row">Career</NavLink>
                  <NavLink onClick={toggleAboutDropdown} to="/pricing" className="content_row">Pricing</NavLink>
                </div>
              </NavLink>
              {/* </div> */}
            
              <NavLink to="/our-works">Our Works</NavLink>
              <NavLink to="/our-clients">Our Clients</NavLink>
            </div>
            <div className="action">
              <NavLink className="case_animation" to="/services/mcp-development">MCP Development</NavLink>
              <NavLink to="/contact">Contact Us</NavLink>
              {/* <button><img src={Category} alt="" /></button>  */}
            </div>
            {/* <div className="action">
              <NavLink className="case_animation" to="/services/ai-agents">AI Agents</NavLink>
              <NavLink to="/contact">Contact Us</NavLink>
          
            </div> */}
          </div>
        </div>
      </section>

      <section className="mobile_nav">
        <div className="nav_wrapper">
          <div className="logo">
            <NavLink to="/">
              <img src={Logo} alt="" />
            </NavLink>
          </div>
          <div
            className={`toggle ${toggle ? "active" : ""}`}
            onClick={handleToggle}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div className={`links ${toggle ? "active" : ""}`}>
            <NavLink to="/">Home</NavLink>
            <div className="drop_wrapper" ref={solutionsDropdownRef}>
              <button className={`link_button ${isSolutionsOpen ? 'dropped' : ''}`} onClick={toggleSolutionsDropdown}> Solutions <img src={Down} alt="" /></button>
              <div className={`dropdown_content ${isSolutionsOpen ? 'active' : ''}`}>
                <NavLink onClick={toggleSolutionsDropdown} to='/solutions/ai-powered-solutions' className="content_row">Healthcare Solutions</NavLink>
                <NavLink onClick={toggleSolutionsDropdown} to='/solutions/cloud-solutions' className="content_row">E-commerce Solutions</NavLink>
                <NavLink onClick={toggleSolutionsDropdown} to='/solutions/data-analytics' className="content_row">Communication Solutions</NavLink>
              </div>
            </div>
            <div className="drop_wrapper" ref={servicesDropdownRef}>
              <button className={`link_button ${isServicesOpen ? 'dropped' : ''}`} onClick={toggleServicesDropdown}> Services <img src={Down} alt="" /></button>
              <div className={`dropdown_content ${isServicesOpen ? 'active' : ''}`}>
                <NavLink onClick={toggleServicesDropdown} to='/services/mcp-development' className="content_row">MCP Development</NavLink>
                <NavLink onClick={toggleServicesDropdown} to='/services/mobile-app-development' className="content_row">Mobile App Development</NavLink>
                <NavLink onClick={toggleServicesDropdown} to='/services/web-app-development' className="content_row">Web App Development</NavLink>
                <NavLink onClick={toggleServicesDropdown} to='/services/ui-ux-designing' className="content_row">UI/UX Design</NavLink>
                <NavLink onClick={toggleServicesDropdown} to='/services/ai-machine-learning-development' className="content_row">AI/ML Development</NavLink>
                {/* <NavLink onClick={toggleServicesDropdown} to="/career"  className="content_row">Career</NavLink> */}
              </div>
            </div>
              {/* Industries Dropdown Mobile */}
              <div className="drop_wrapper" ref={industriesDropdownRef}>
              <button className={`link_button ${isIndustriesOpen ? 'dropped' : ''}`} onClick={toggleIndustriesDropdown}> Industries <img src={Down} alt="" /></button>
              <div className={`dropdown_content ${isIndustriesOpen ? 'active' : ''}`}>
                <NavLink onClick={toggleIndustriesDropdown} to="/industries/education" className="content_row">Education</NavLink>
                <NavLink onClick={toggleIndustriesDropdown} to="/industries/healthcare" className="content_row">Healthcare Industry</NavLink>
                <NavLink onClick={toggleIndustriesDropdown} to="/industries/petcare" className="content_row">PetCare Industry</NavLink>
                <NavLink onClick={toggleIndustriesDropdown} to="/industries/homecare" className="content_row">Homecare</NavLink>
                <NavLink onClick={toggleIndustriesDropdown} to="/industries/social-media" className="content_row">Social Media App</NavLink>
                <NavLink onClick={toggleIndustriesDropdown} to="/industries/dating" className="content_row">Dating app</NavLink>
                <NavLink onClick={toggleIndustriesDropdown} to="/industries/fitness" className="content_row">Fitness</NavLink>
                <NavLink onClick={toggleIndustriesDropdown} to="/industries/textile-garments" className="content_row">Textile Garments</NavLink>
              </div>
            </div>
            {/* <NavLink to="/about">About Us</NavLink> */}
            <div className="drop_wrapper" ref={aboutDropdownRef}>
              <button className={`link_button ${isAboutOpen ? 'dropped' : ''}`} onClick={toggleAboutDropdown}> About <img src={Down} alt="" /></button>
              <div className={`dropdown_content ${isAboutOpen ? 'active' : ''}`}>
                <NavLink onClick={toggleAboutDropdown} to='/about' className="content_row">About Us</NavLink>
                <NavLink onClick={toggleAboutDropdown} to='/our-story' className="content_row">Our Story</NavLink>
                <NavLink onClick={toggleAboutDropdown} to='/our-journey' className="content_row">Our Journey</NavLink>
                <NavLink onClick={toggleAboutDropdown} to='/life-at-koolmind' className="content_row">Life at KoolMind</NavLink>
                <NavLink onClick={toggleAboutDropdown} to="/career" className="content_row">Career</NavLink>
                <NavLink onClick={toggleAboutDropdown} to="/pricing" className="content_row">Pricing</NavLink>
              </div>
            </div>
           
            <NavLink to="/our-works">Our Works</NavLink>
            <NavLink to="/our-clients">Our Clients</NavLink>
            <div className="action">
              <NavLink to="/services/ai-agents">AI Agents</NavLink>
              <NavLink to="/contact">Contact Us</NavLink>
              {/* <button>
                    <img src={Category} alt="" />
                  </button> */}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
